import styled from "styled-components";
import {HistoryModel} from "./model";

export const History = styled(HistoryModel)`
  #root & {
    width: 100%;
    padding: 1rem;
    margin: 0;
  }
`